/* To test the exceptional cases under productin mode */

import { endpoint } from "service/endpoint";
// import Papa from "papaparse";

const Axios = require("axios");

export async function getData(filename) {
  try {
    
    return process.env.NODE_ENV === "production"
      ? Axios.get(endpoint.concat(`${filename}.json`),{
        // query URL without using browser cache
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
        },
      })
        .then((result) => {
          // console.log("lineData :>> ", result);
          return result.data;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            console.log('File not found!');
            console.log("err :>> ", err);
          } else
            throw err;
          // return [];
        })
      : new Promise((res, rej) => {
        setTimeout(() => {
          let LineData;
          // console.debug("debug ../assets/data/.json",  filename);
          try {
            LineData = require(`../assets/data/${filename}.json`);
            // require(`./assets/data/test.pl`);
          } catch (error) {
            if (error.code === 'MODULE_NOT_FOUND') {
              console.log('File not found!');
            } else {
              throw error;
            }
          }
          res(LineData);
        }, 3500);
      });
  } catch (error) {
    console.log(error);
  }
}

export async function getFile(filename) {
  try {
    return Axios.get(`./${filename}`)
    .then((result) => {
      return result.data;
    })
    .catch((err) => {
      if (err.response.status === 404) {
        console.log('File not found!');
        console.log("err :>> ", err);
      } else
        throw err;
      // return [];
    })
  } catch (error) {
    console.log(error);
  }
}

// export async function getPyData( ) {
//   const formData = new FormData();
//   formData.append('timestamp', Date.now());
//   // return fetch(`/cgi-bin/${filename}.pl`,
//   return process.env.NODE_ENV === "production"
//     ? fetch(`${process.env.REACT_APP_PYTHON_FILE_PATH}getalldata.py`,
//       // ? fetch(`http://localhost/cgi-bin/${filename}.pl`,
//       {
//         method: 'POST',
//         body: formData
//       })
//       .then((response) => {
//         // console.log(response)
//         return response.json()
//       })
//       .then((responseData) => {
//         // console.log(responseData);
//         return responseData;
//       })
//       .catch(error => console.warn(error))
//     : new Promise((res, rej) => {
//       setTimeout(() => {
//         let LineData;
//         // console.debug("debug ../assets/data/.json", local_sessionid, filename);
//         try {
//           LineData = require(`../assets/data/getalldata.json`);
//           // require(`./assets/data/test.pl`);
//         } catch (error) {
//           if (error.code === 'MODULE_NOT_FOUND') {
//             console.log('File not found!');
//           } else {
//             throw error;
//           }
//         }
//         res(LineData);
//       }, 3500);
//     });
// }
